
import { Project } from '@/model/Project';
import Vue, { PropType } from 'vue'
import moment from 'moment'
import {ContestApplication} from "@/model/ContestApplication";

const DISPLAY_LIMIT = 6;

type Application = {
  applicationId: string;
  name: string;
  slug: string;
  reward: number | undefined;
  isFinished: boolean;
}

export default Vue.extend({
  name: 'ContestList',

  props: {
    project: {
      type: Object as PropType<Project>,
    },
    applicationsArray: {
      type: Array as PropType<ContestApplication[]>
    }
  },

  data: () => ({
    isExpanded: false,
    displayLimit: DISPLAY_LIMIT,
  }),

  computed: {
    applications(): Application[] {
      if (!this.applicationsArray || !Array.isArray(this.applicationsArray)) {
        return [];
      }

      const parsed = this.applicationsArray.map(app => this.parseApplication(app));

      return parsed.sort((a, b) => {
        if (a.reward && !b.reward) return -1;
        if (!a.reward && b.reward) return 1;

        if (!a.isFinished && b.isFinished) return -1;
        if (a.isFinished && !b.isFinished) return 1;

        return 0;
      }).slice(0, this.isExpanded ? undefined : DISPLAY_LIMIT);
    }
  },

  methods: {
    toggleExpanded() {
      this.isExpanded = !this.isExpanded;
    },

    parseApplication(app: ContestApplication): Application {
      return {
        applicationId: app.id,
        name: app.contest.name,
        slug: app.contest.slug,
        reward: app.place ?? undefined,
        isFinished: moment(app.contest.contestFinishedAt).isBefore(moment()),
      };
    },

    getClass(reward: number) {
      if (reward === 1) return 'gold';
      if (reward === 2) return 'silver';
      if (reward === 3) return 'bronze';

      return '';
    },
  }
})
